/** Shared layout for static information pages (footer destinations). */
import type { ReactNode } from "react";

export function InfoLayout({
  title,
  lead,
  children,
}: {
  title: string;
  lead?: string;
  children: ReactNode;
}) {
  return (
    <div className="info-page">
      <header className="info-header">
        <h1>{title}</h1>
        {lead && <p className="info-lead">{lead}</p>}
      </header>
      {children}
    </div>
  );
}
